import type { ThreatLevel } from '@/types';
import { THREAT_NAMES } from '@/config';
import { store } from '@/state';
import { showToast } from './toast';

/**
 * Initialize threat filter buttons
 */
export function initThreatFilter(): void {
  const badges = document.querySelectorAll('.threat-badge');

  badges.forEach((badge) => {
    badge.addEventListener('click', () => {
      const threatStr = (badge as HTMLElement).dataset.threat;
      if (threatStr === undefined) return;

      const threat = parseInt(threatStr, 10) as ThreatLevel;
      const isEnabled = store.toggleThreatLevel(threat);

      // Update badge appearance
      if (isEnabled) {
        badge.classList.remove('disabled');
      } else {
        badge.classList.add('disabled');
      }

      // Show toast notification
      const threatName = THREAT_NAMES[threat];
      const status = isEnabled ? 'enabled' : 'disabled';
      showToast(`Threat ${threat} (${threatName}) ${status}`);
    });
  });
}

/**
 * Enable all threat levels
 */
export function enableAllThreatLevels(): void {
  const badges = document.querySelectorAll('.threat-badge');

  for (let level = 0; level <= 5; level++) {
    const state = store.getState();
    if (!state.enabledThreatLevels.has(level as ThreatLevel)) {
      store.toggleThreatLevel(level as ThreatLevel);
    }
  }

  badges.forEach((badge) => {
    badge.classList.remove('disabled');
  });
}

/**
 * Disable all threat levels
 */
export function disableAllThreatLevels(): void {
  const badges = document.querySelectorAll('.threat-badge');

  for (let level = 0; level <= 5; level++) {
    const state = store.getState();
    if (state.enabledThreatLevels.has(level as ThreatLevel)) {
      store.toggleThreatLevel(level as ThreatLevel);
    }
  }

  badges.forEach((badge) => {
    badge.classList.add('disabled');
  });
}
